import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * @description Servicio transversal para consultas y mutaciones GraphQL
 * hacia las diferentes APIs del sistema.
 */
@Injectable({
  providedIn: 'root',
})
export class GraphService {
  constructor(private http: HttpClient) { }

  /**
   * @description Ejecuta una consulta GraphQL contra Financials API.
   * @param options - Objeto con query y variables.
   * @returns Observable con la data tipada.
   */
  public queryGraphQL<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T; errors?: any }>(`${environment.financialsApi}/graphql`, {
        query: options.query,
        variables: options.variables,
      })
      .pipe(
        map((response: any) => {
          if (response.errors) {
            throw new Error(
              response.errors.map((err: any) => err.message).join(', ')
            );
          }
          return response.data;
        }),
        catchError((error) => {
          return throwError(
            () =>
              new Error(
                error.message || 'Hubo un error ,por favor intentelo mas tarde.'
              )
          );
        })
      );
  }

  /**
   * @description Ejecuta una consulta GraphQL contra Sourcing API.
   * @param options - Objeto con query y variables.
   * @returns Observable con la data tipada.
   */
  public queryGraphQLSourcing<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T; errors?: any }>(`${environment.sourcingApi}/graphql`, {
        query: options.query,
        variables: options.variables,
      })
      .pipe(
        map((response: any) => {
          if (response.errors) {
            throw new Error(
              response.errors.map((err: any) => err.message).join(', ')
            );
          }
          return response.data;
        }),
        catchError((error) => {
          return throwError(
            () =>
              new Error(
                error.message || 'Hubo un error ,por favor intentelo mas tarde.'
              )
          );
        })
      );
  }

  /**
   * @description Ejecuta una consulta GraphQL contra Sales API.
   * @param options - Objeto con query y variables.
   * @returns Observable con la data tipada.
   */
  public queryGraphQLSales<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T; errors?: any }>(`${environment.salesApi}/graphql`, {
        query: options.query,
        variables: options.variables,
      })
      .pipe(
        map((response: any) => {
          if (response.errors) {
            throw new Error(
              response.errors.map((err: any) => err.message).join(', ')
            );
          }
          return response.data;
        }),
        catchError((error) => {
          console.error(error);
          return throwError(
            () =>
              new Error(
                error.message || 'Hubo un error ,por favor intentelo mas tarde.'
              )
          );
        })
      );
  }

  /**
   * @description Ejecuta una consulta GraphQL contra Product API.
   * @param options - Objeto con query y variables.
   * @returns Observable con la data tipada.
   */
  public queryGraphQLProduct<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T; errors?: any }>(`${environment.productApi}/graphql`, {
        query: options.query,
        variables: options.variables,
      })
      .pipe(
        map((response: any) => {
          if (response.errors) {
            throw new Error(
              response.errors.map((err: any) => err.message).join(', ')
            );
          }
          return response.data;
        }),
        catchError((error) => {
          return throwError(
            () =>
              new Error(
                error.message || 'Hubo un error ,por favor intentelo mas tarde.'
              )
          );
        })
      );
  }

  /**
   * @description Ejecuta una consulta GraphQL contra Operations API.
   * @param options - Objeto con query y variables.
   * @returns Observable con la data tipada.
   */
  public queryGraphQLOperations<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T; errors?: any }>(`${environment.operationsApi}/graphql`, {
        query: options.query,
        variables: options.variables,
      })
      .pipe(
        map((response: any) => {
          if (response.errors) {
            throw new Error(
              response.errors.map((err: any) => err.message).join(', ')
            );
          }
          return response.data;
        }),
        catchError((error) => {
          return throwError(
            () =>
              new Error(
                error.message || 'Hubo un error ,por favor intentelo mas tarde.'
              )
          );
        })
      );
  }

  /**
   * @description Ejecuta una consulta GraphQL contra AyB API.
   * @param options - Objeto con query y variables.
   * @returns Observable con la data tipada.
   */
  public queryGraphQLAyB<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T; errors?: any }>(`${environment.aybApi}/graphql`, {
        query: options.query,
        variables: options.variables,
      })
      .pipe(
        map((response: any) => {
          if (response.errors) {
            throw new Error(
              response.errors.map((err: any) => err.message).join(', ')
            );
          }
          return response.data;
        }),
        catchError((error) => {
          return throwError(
            () =>
              new Error(
                error.message || 'Hubo un error ,por favor intentelo mas tarde.'
              )
          );
        })
      );
  }

  /**
   * @description Ejecuta una consulta GraphQL contra Core API.
   * @param options - Objeto con query y variables.
   * @returns Observable con la data tipada.
   */
  public queryGraphQLCore<T>(options: {
    query: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T; errors?: any }>(`${environment.coreApi}/graphql`, {
        query: options.query,
        variables: options.variables,
      })
      .pipe(
        map((response: any) => {
          if (response.errors) {
            throw new Error(
              response.errors.map((err: any) => err.message).join(', ')
            );
          }
          return response.data;
        }),
        catchError((error) => {
          return throwError(
            () =>
              new Error(
                error.message || 'Hubo un error ,por favor intentelo mas tarde.'
              )
          );
        })
      );
  }

  /**
   * @description Ejecuta una mutacion GraphQL contra Financials API.
   * @param options - Objeto con mutation y variables.
   * @returns Observable con la respuesta.
   */
  public mutateGraphQL<T>(options: {
    mutation: string;
    variables?: { [key: string]: any };
  }): Observable<any> {
    return this.http
      .post<{ data: T; errors?: any }>(`${environment.financialsApi}/graphql`, {
        query: options.mutation,
        variables: options.variables,
      })
      .pipe(
        map((response: any) => {
          if (response.errors) {
            const graphQLErrors = response.errors as any[];
            const primaryError = graphQLErrors[0];
            const requestError = new Error(
              graphQLErrors.map((err: any) => err.message).join(', ')
            ) as Error & {
              code?: string;
              statusCode?: number;
              orderIds?: string[];
            };
            requestError.code = primaryError?.extensions?.code;
            requestError.statusCode = primaryError?.extensions?.statusCode;
            requestError.orderIds = primaryError?.extensions?.orderIds;
            throw requestError;
          }
          return response.data;
        }),
        catchError((error) => {
          console.error('graphql error');
          console.error(error);
          return throwError(() =>
            error instanceof Error
              ? error
              : new Error(
                  error?.message ||
                    'Hubo un error ,por favor intentelo mas tarde.'
                )
          );
        })
      );
  }

  /**
   * @description Ejecuta una mutacion GraphQL contra Sales API.
   * @param options - Objeto con mutation y variables.
   * @returns Observable con la respuesta.
   */
  public mutateGraphQLSales<T>(options: {
    mutation: string;
    variables?: { [key: string]: any };
  }): Observable<any> {
    return this.http
      .post<{ data: T }>(`${environment.salesApi}/graphql`, {
        query: options.mutation,
        variables: options.variables,
      })
      .pipe(
        map((response: any) => {
          if (response.errors && response.errors.length > 0) {
            throw new Error(response.errors[0].message);
          }
          return response.data;
        }),
        catchError((error) => {
          console.error('Error en mutacion a Sales API:', error);
          return throwError(() => error);
        })
      );
  }

  /**
   * @description Ejecuta una mutación GraphQL contra Core API.
   */
  public mutateGraphQLCore<T>(options: {
    mutation: string;
    variables?: { [key: string]: any };
  }): Observable<T> {
    return this.http
      .post<{ data: T; errors?: any[] }>(`${environment.coreApi}/graphql`, {
        query: options.mutation,
        variables: options.variables,
      })
      .pipe(
        map((response) => {
          if (response.errors?.length) {
            throw new Error(
              response.errors.map((error: any) => error.message).join(', ')
            );
          }
          return response.data;
        }),
        catchError((error) =>
          throwError(
            () =>
              new Error(
                error.message || 'Hubo un error ,por favor intentelo mas tarde.'
              )
          )
        )
      );
  }
}
